export default "__VITE_ASSET__BFnI8EBI__"